import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const steps = [
  {
    number: 1,
    title: 'Sign Up & Set Up',
    desc: 'Create your account and add your business details -GST, logo, products, and customers.'
  },
  {
    number: 2,
    title: 'Start Creating Invoices',
    desc: 'Generate GST-compliant invoices, share via WhatsApp, SMS, or print instantly.'
  },
  {
    number: 3,
    title: 'Manage Customer & Stock',
    desc: 'Track purchases, sales, stock levels, and godown-wise inventory in real time.'
  },
  {
    number: 4,
    title: 'Track Payments & Reports',
    desc: 'Record payments, send reminders, and get auto-generated business reports and tax summaries.'
  }
];

const HowItWorks = () => (
  <section className="section howitworks__v1" id="how-it-works">
    <Container>
      <Row className="mb-5">
        <Col md={6} className="text-center mx-auto">
          <span className="subtitle text-uppercase mb-3">How it works</span>
          {/*<h2 className="mb-4">How It Works</h2>*/}
		  <h3 className="mb-4">Start Billing in Minutes It’s That Simple!</h3>
          <p>Switching to smart billing doesn’t have to be complicated. HamaraBillBook is designed to get your business up and running in just a few easy steps.</p>
        </Col>
      </Row>
      <Row className="g-md-5">
        {steps.map((step, idx) => (
          <Col md={6} lg={3} key={idx} className="mb-4">
            <Card className="step-card text-center h-100 d-flex flex-column justify-content-start position-relative">
              <span className="step-number rounded-circle text-center fw-bold mb-5 mx-auto">{step.number}</span>
              <Card.Body>
                <Card.Title as="h3" className="fs-5 mb-4">{step.title}</Card.Title>
                <Card.Text>{step.desc}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default HowItWorks; 